import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { useAuth } from "../auth/AuthContext";
import saccascanLogo from "../assets/saccascan-logo.png";
import { homePathForRole } from "../auth/RoleGuard";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(homePathForRole(user.role, user.is_superuser));
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err: any) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        px: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 420, borderRadius: 3, boxShadow: "0 8px 32px rgba(20,30,50,.10)" }}>
        <CardContent sx={{ px: 4, py: 4 }}>
          {/* Бренд-блок: MultiCog Physician Dashboard */}
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Box
              component="img"
              src={saccascanLogo}
              alt="SaccaScan.ai"
              sx={{ width: 270, maxWidth: "100%", display: "block", mx: "auto", mb: 2 }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: 0.3, lineHeight: 1.1 }}>
              MultiCog
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "primary.main", fontWeight: 600, mb: 1 }}>
              Physician Dashboard
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", px: 1 }}>
              Digital cognitive assessment: tests run on iPad, results and the
              MultiCog scale appear in your dashboard.
            </Typography>
          </Box>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              autoComplete="email"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 2 }}
            >
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>
          <Typography
            variant="caption"
            sx={{ display: "block", textAlign: "center", color: "text.secondary", mt: 2 }}
          >
            Access is provided by your administrator · SaccaScan
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
